export class ConcernedPersonModel {
    dhpId : any;
    ipaId : string;
    chpId : string;
  }